import axios from '../axios';
const apiPath = 'api/admin/auths/login';

const authApi = {
    login: function(entity) {
        return axios.post(`${process.env.VUE_APP_API_ENDPOINT}/${apiPath}`, {
            ...entity
        });
    }
};

export default authApi;
